import Cookies from "js-cookie";

const COOKIE_NAME = "glavnoe_uid";
const COOKIE_EXPIRES = 365;

const generateUserId = () => {
    const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from({ length: 16 }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
};

export const getUserId = () => {
    let userId = Cookies.get(COOKIE_NAME);

    if (!userId) {
        userId = generateUserId();
        Cookies.set(COOKIE_NAME, userId, {
            expires: COOKIE_EXPIRES,
            path: "/",
            sameSite: "strict",
        });
    }

    return userId;
};
